import genericErrorModalEn from "./locales/en.json";

export const GENERIC_ERROR_MODAL_NS = "genericErrorModal" as const;

export const GenericErrorModalI18n = {
  en: {
    [GENERIC_ERROR_MODAL_NS]: {
      ...genericErrorModalEn,
    },
  },
};
